import type { ReactNode } from "react";
import { useTranslation } from "src/i18n";
import { Button, Flex } from "src/elements";

interface Props {
  isShown: boolean;

  onBackToO?: () => void;

  inFront?: (rules: ReactNode) => ReactNode;
  children: ReactNode;
}

export const AdvancedRules = ({ isShown, onBackToO, inFront, children }: Props) => {
  const { t } = useTranslation("common");

  const rules = isShown ? (
    <Flex minHeight="0" flexGrow column gap="10px">
      {onBackToO && (
        <Flex padding="10px 10px 0">
          <Button color="primary" variant="inverted" onClick={onBackToO}>
            ‹ {t("configCopilot.backToO")}
          </Button>
        </Flex>
      )}

      {children}
    </Flex>
  ) : null;

  return inFront ? inFront(rules) : rules;
};
